import { ConnectionType } from 'primary-schema';

import { type api, isTruthy } from 'common';

/**
 * FIXME: This is a temporary solution to get the filter options.
 * Endpoints or Enum's must be created to populate the filter options.
 * This must be fixed before implementing pagination on this page.
 */
export function mapConnectorsPageFilterOptions(connections: api.Connection.Connection[]) {
  const sources = new Set<string>();
  const destinations = new Set<string>();
  const methods = new Set<string>();
  const dataTypes = new Set<string>();

  for (const connection of connections) {
    if (isTruthy(connection.source)) {
      sources.add(connection.source);
    }
    if (isTruthy(connection.destination)) {
      destinations.add(connection.destination);
    }
    if (isTruthy(connection.method)) {
      methods.add(connection.method);
    }
    if (isTruthy(connection.dataType)) {
      dataTypes.add(connection.dataType);
    }
  }

  return {
    source: [...sources],
    destination: [...destinations],
    connectivity: [...methods],
    format: [...dataTypes],
  };
}

export const connectorDetailsPathByConnectionType = {
  [ConnectionType.Api]: '/connections/api',
  [ConnectionType.Sftp]: '/connections/sftp',
  [ConnectionType.InterfaceEngine]: '/connections/interface-engine',
  [ConnectionType.IntegrationEngine]: '/resource-gateway/connections',
};

export const connectionNameByConnectionType = {
  [ConnectionType.Api]: 'API',
  [ConnectionType.Sftp]: 'SFTP',
  [ConnectionType.InterfaceEngine]: 'Interface Engine',
  [ConnectionType.IntegrationEngine]: 'Integration Engine',
};

export const connectionTypeToUrlPath: Record<ConnectionType, string> = {
  [ConnectionType.Api]: 'Api',
  [ConnectionType.Sftp]: 'Sftp',
  [ConnectionType.InterfaceEngine]: 'InterfaceEngine',
  [ConnectionType.IntegrationEngine]: 'IntegrationEngine',
};

/**
 * Maps URL path segment back to ConnectionType
 */
export const urlPathToConnectionType: Record<string, ConnectionType> = {
  Api: ConnectionType.Api,
  Sftp: ConnectionType.Sftp,
  InterfaceEngine: ConnectionType.InterfaceEngine,
  IntegrationEngine: ConnectionType.IntegrationEngine,
};

export enum ConnectorsDetailsMode {
  Drawer = 'drawer',
  Page = 'page',
}
